import React from "react";
import { Breadcrumb } from "antd";
import { RightOutlined } from "@ant-design/icons";
import styled from "styled-components";
import { useSelector } from "react-redux";
const Wraper = styled.div`
  .ant-breadcrumb > span:nth-child(1) {
    font-weight: 600;
    font-size: 24px;
    line-height: 36px;
    letter-spacing: 0.3px;
    color: #404e67;
  }
  .ant-breadcrumb-separator {
    display: inline-flex;
  }
  .ant-breadcrumb svg {
    color: #5b6679;
  }
  .ant-breadcrumb > span {
    font-weight: 500;
    font-size: 16px;
    line-height: 27px;
    letter-spacing: 0.3px;
    color: #5b6679;
  }
`;

export const LeftContainer = () => {
  const PageRoot = useSelector((state) => state.pageRoot.page);
  return (
    <Wraper>
      <Breadcrumb separator={<RightOutlined />}>
        <Breadcrumb.Item>
          {PageRoot.area ? PageRoot.area : "Dashboard"}
        </Breadcrumb.Item>
        <Breadcrumb.Item>{PageRoot.subArea}</Breadcrumb.Item>
        <Breadcrumb.Item>{PageRoot.subArea2}</Breadcrumb.Item>
        <Breadcrumb.Item>{PageRoot.subArea3}</Breadcrumb.Item>
      </Breadcrumb>
    </Wraper>
  );
};
